import {property} from 'lodash';



/**
 *
 */
export const getUser = property('user');
export const getUserId = property('user.id');
